import Modal from "../../Modal";
import useStrings from "../../../hooks/useStrings";

import { IResource } from "../../../commons/interfaces";
import AddResource from "./AddResource";

interface IProps {
    serviceCode: string;
    data: IResource[];
    visibled: boolean;
    onClose: () => void;
    onSubmit: (resourceData: IResource[]) => void;
}

export const ModalAddResource = ({ data, visibled, serviceCode, onClose, onSubmit }: IProps) => {
    const strings = useStrings();
    const handleAction = (resourceData: IResource[]) => {
        onSubmit(resourceData);
        return onClose();
    };

    return (
        <Modal
            fullWidth
            maxWidth="xs"
            // hasActionButton
            // onAction={() => handleAction()}
            onClose={onClose}
            visible={visibled}
            title={strings.Role.RESOURCE}
            buttonAction={strings.Common.SAVE}
        >
            <>
                <AddResource serviceCode={serviceCode} resourceData={data} onSubmit={handleAction} onClose={onClose} />
            </>
        </Modal>
    );
};

export default ModalAddResource;
